<template>

  <div class="modal fade light " id="modalWithdraw" ref="bank" tabindex="-1" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-background modal-lg">
      <div class="modal-content">
        <div class=" ">
          <header class="modal-card-head">
            <p class="modal-card-title">ถอนเงิน</p><button aria-label="close" data-dismiss="modal"
              class="delete"></button>
          </header>
          <section class="modal-card-body">
            <div data-v-e37d86a0="" class="box-withdraw">
              <div data-v-e37d86a0="" class="from">
                <section data-v-e37d86a0="" tabindex="0" class="box-slide hooper is-vertical">
                  <div class="hooper-list">
                    <ul class="hooper-track" style="transform: translate(0px, 0px);">
                      <li data-v-e37d86a0="" class="hooper-slide is-active is-current" style="height: 150px;">
                        <div data-v-e37d86a0=""><img data-v-e37d86a0="" src="/static/img/user/wallet.19799654.png">
                          <div data-v-e37d86a0="" class="name">Wallet (บาท)</div>
                          <div data-v-e37d86a0="" class="amount">{{ UserInfo.internalWallet.gameWallet }}</div>
                        </div>
                      </li>
                    </ul>
                    <div data-v-e37d86a0="" class="hooper-navigation is-vertical">
                    </div>
                    <div aria-live="polite" aria-atomic="true" class="hooper-liveregion hooper-sr-only">Item 1 of 1
                    </div>
                  </div>
                </section>
              </div>
            </div>
            <form data-v-e37d86a0="">
              <div data-v-e37d86a0="" class="field m-t-30">
                <!-- <label data-v-e37d86a0="" for="" class="label">จำนวนเงิน
                  (บาท) <span data-v-e37d86a0="" class="note">**ขั้นต่ำ 5 บาท / สูงสุด 20,000 บาท**</span>
                </label> -->

                <div data-v-e37d86a0="" class="control has-icons-left">
                  <input data-v-e37d86a0="" type="number" min="0" placeholder="จำนวนเงิน" v-model="amount"
                    required="required" class="input text-center"><span data-v-e37d86a0=""
                    class="icon is-small is-left"><i data-v-e37d86a0="" class="fas fa-coins"></i></span>
                </div>
              </div>
              <div data-v-e37d86a0="" class="box-button m-t-30">
                <button data-dismiss="modal" data-v-e37d86a0="" class="button full-50 is-light"> ยกเลิก </button>
                <button data-v-e37d86a0="" @click="Withdraw()" type="submit" class="button full-50 is-primary"> ยืนยัน
                </button>
              </div>
            </form>

          </section>
        </div>
      </div>
    </div>
  </div>




</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { UserInfoMixins } from '@/mixins/UserInfo.js'
import { PrefixMixins } from '@/mixins/Prefix.js'
import { BankMixins } from '@/mixins/BankService.js'

import { Withdraw } from '@/services/modules/withdraw.js'
import moment from 'moment'

export default {
  name: 'WithdrawForm',
  mixins: [UserInfoMixins, PrefixMixins, BankMixins],

  data() {
    return {
      amount: '',
    }
  },
  computed: {
    ...mapGetters([
      'getError',
      'getLoading',
      'getLineId',
      'getGameList',
      'getPromotion',
      'getPrefix',
    ]),
  },
  methods: {
    async copybank(item) {
      this.$copyText(item, this.$refs.withdraw)
      this.$swal.fire('คัดลอกแล้ว', '', 'success')
    },
    async Withdraw() {
      await Withdraw(this.amount, this.Prefix.Withdraw.minWithdraw, (res) => {
        if (res.status) {
          this.$swal.fire('Success!', '', 'success')
        } else {
          this.$swal.fire(res.message, '', 'error')
        }
      })
    },
  },
  async mounted() { },
}
</script>
<style scoped>
.modal-dialog[data-v-6c8d75ed] {
  min-width: 720px;
}

.modal-dialog .modal-content[data-v-6c8d75ed] {
  background-color: #151515;
  border-radius: 10px;
  box-shadow: 0 0 5px #000;
}

.modal-dialog .modal-content .modal-body .header-label[data-v-6c8d75ed] {
  color: #fff;
  font-weight: 700;
  font-size: 18px;
  text-align: center;
  padding: 0.8rem 0.5rem;
  margin-top: 0.3rem;
  margin-bottom: 0.5rem;
  background: linear-gradient(180deg, #a44bc9, #6200b5);
  border-radius: 4px;
}

.modal-dialog .modal-content .modal-header .btn-close[data-v-6c8d75ed] {
  color: #fff;
  background: none;
  width: auto;
  height: auto;
}

.modal-header .btn-close {
  padding: calc(var(--bs-modal-header-padding-y) * 0.5) calc(var(--bs-modal-header-padding-x) * 0.5);
  margin: calc(var(--bs-modal-header-padding-y) * -0.5) calc(var(--bs-modal-header-padding-x) * -0.5) calc(var(--bs-modal-header-padding-y) * -0.5) auto;
}

.modal-dialog .modal-content .modal-header[data-v-6c8d75ed] {
  color: #fff;
  border-bottom: none;
  padding: 0.225rem 0.5rem;
}

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-modal-header-padding);
  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);
  border-top-left-radius: var(--bs-modal-inner-border-radius);
  border-top-right-radius: var(--bs-modal-inner-border-radius);
}

.modal-dialog .modal-content .modal-body[data-v-6c8d75ed] {
  padding-top: 0;
}

.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--bs-modal-padding);
}

#cashback .blog-cashback[data-v-4ad267e1] {
  padding: 1rem 1rem 0;
  color: #fff;
  background: rgba(0, 0, 0, 0.8);
}

.blog-data-amount h2[data-v-4ad267e1] {
  color: #f7ac03;
  font-weight: 600;
  font-size: 2.5rem;
  margin: 0;
}

table,
td,
th {
  padding: 5px;
}

table {
  width: 100%;
  border-collapse: collapse;
}

td {
  padding: 5px;
}

#comp-list-bonus-other {
  display: grid;
  gap: 7px;
  grid-template-areas: '. . ';
}

#content-table-resx {
  background: linear-gradient(rgb(249, 220, 78) 0%,
      rgb(118, 115, 19) 100%) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/form/WithdrawForm.vue